"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("@mui/material/styles");
const material_1 = require("@mui/material");
const base_ui_theme_1 = require("@motorata/base-ui.theme");
const StyledSlider = (0, styles_1.styled)(material_1.Slider)(() => ({
    "height": 25,
    "padding": "0",
    "& .MuiSlider-thumb": {
        "height": 25,
        "width": 20,
        "backgroundColor": "#fff",
        "borderRadius": 3,
        "border": "1.5px solid currentColor",
        "marginTop": 0,
        // "marginLeft": -10,
        "&:hover": {
            boxShadow: " 0px 0px 0px 8px rgb(106 103 212 / 16%);",
        },
        "&:focus, &:hover, &$active": {
            boxShadow: "#fff 0 0 0 0",
        },
        "& .bar": {
            height: 9,
            width: 1,
            backgroundColor: "currentColor",
            borderRadius: 5,
            margin: "0 2px",
        },
        "&::after": {
            display: "none",
        },
    },
    "active": {},
    "& .MuiSlider-track": {
        height: 25,
        borderRadius: 5,
    },
    "& .MuiSlider-rail": {
        color: base_ui_theme_1.baseTheme.color.fourth,
        opacity: 1,
        height: 25,
        borderRadius: 5,
    },
}));
// @ts-ignore
function StyledSliderThumbComponent(props) {
    return (react_1.default.createElement("span", Object.assign({}, props),
        react_1.default.createElement("span", { className: "bar" }),
        react_1.default.createElement("span", { className: "bar" })));
}
function Slider(_a) {
    var { name, value, 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange = () => { }, min, max, step } = _a, rest = __rest(_a, ["name", "value", "onChange", "min", "max", "step"]);
    const handleChange = (event, value, activeThumb) => {
        onChange({
            name,
            value,
        });
    };
    return (react_1.default.createElement(Content, Object.assign({}, rest),
        react_1.default.createElement(StyledSlider
        // @ts-ignore
        , { 
            // @ts-ignore
            ThumbComponent: StyledSliderThumbComponent, getAriaLabel: index => (index === 0 ? "Minimum price" : "Maximum price"), defaultValue: value, value: value, min: min, max: max, step: step, onChange: handleChange })));
}
exports.default = Slider;
const Content = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  
  .MuiSlider-track{
    color: ${({ theme }) => theme.color.primary};
  }
`;
//# sourceMappingURL=index.js.map